/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partnersassignsearch2Inputs */

const en_partnersassignsearch2 = /** @type {(inputs: Partnersassignsearch2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search businesses`)
};

const de_partnersassignsearch2 = /** @type {(inputs: Partnersassignsearch2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Betrieb suchen`)
};

/**
* | output |
* | --- |
* | "Search businesses" |
*
* @param {Partnersassignsearch2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const partnersassignsearch2 = /** @type {((inputs?: Partnersassignsearch2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partnersassignsearch2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_partnersassignsearch2(inputs)
	return de_partnersassignsearch2(inputs)
});
export { partnersassignsearch2 as "partnersAssignSearch" }